import {createAction} from '@reduxjs/toolkit';

export const setLabels = createAction('UI_SET_LABELS');
export const setMode = createAction('UI_SET_MODE');
export const setDrawMode = createAction('UI_SET_DRAW_MODE');

export const drawModes = {
  POINT: 'point',
  AREA: 'area',
};

export const modes = {
  COMPARE: 'compare',
  SELECTION: 'selection',
  NONE: 'none',
};
